import ContentContainer from "Components/Container/ContentContainer";
import {
  BackButton,
  Button,
  Input,
  SubTitle,
} from "Components/CustomComponents";
import { logout } from "Data/features/authSlice";
import { useChangePasswordMutation } from "Data/services/userAuthApi";
import { getErrorMessage } from "Hooks/useErrorHandler";
import { ErrorToast, SuccessToast } from "Hooks/useToast";
import React, { useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import styles from "./ChangePassword.module.scss";

export interface ChangePasswordFormData {
  current_password: string;
  new_password: string;
  confirm_password: string;
}

const ChangePassword: React.FC = () => {
  const dispatch = useDispatch()
  const {
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm<ChangePasswordFormData>({
    mode: "onChange",
    defaultValues: {
      current_password: "",
      new_password: "",
      confirm_password: "",
    },
  });

  const currentPassword = watch("current_password");
  const newPassword = watch("new_password");
  const confirmPassword = watch("confirm_password");

  useEffect(() => {
    if (errors.current_password?.message) {
      ErrorToast(errors.current_password.message as string);
    } else if (errors.new_password?.message) {
      ErrorToast(errors.new_password.message as string);
    } else if (errors.confirm_password?.message) {
      ErrorToast(errors.confirm_password.message as string);
    }
  }, [
    errors.current_password?.message,
    errors.new_password?.message,
    errors.confirm_password?.message,
  ]); // Trigger when errors change


  // const { id } = useParams<{ id: string }>();
  // console.log(id);

  const [changePassword, { isLoading }] = useChangePasswordMutation();

  const handleProfile = async (data: ChangePasswordFormData) => {
    // console.log("handleProfile");
    // console.log(data);
    try {
      const response = await changePassword(data).unwrap();
      if (response.code === 200) {
        SuccessToast(response.message);
        dispatch(logout())
      }
    } catch (error: unknown) {
      // console.log("Change Password Error:", error);
      ErrorToast(getErrorMessage(error));
    }
  };

  return (
    <div className={styles.ChangePassword}>
      <BackButton isRelative={true} text="Change Password" classes="mb-1" />

      <ContentContainer
        bg="#ffffff"
        classes="d-flex justify-content-center p-4"
        style={{ borderRadius: "12px" }}
        hasBoxShadow={true}
      >
        <div className={`${styles.profileCard}`}>
          <SubTitle text={"Change Password"} classes="mb-3" />
          <Form onSubmit={handleSubmit(handleProfile)}>
            <Controller
              control={control}
              name="current_password"
              rules={{ required: "Current Password is required." }}
              render={({ field: { onChange, value } }) => (
                <Input
                  placeholder="Current password"
                  type="text"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            <Controller
              control={control}
              name="new_password"
              rules={{
                required: "New Password is required.",
                validate: (value) => {
                  if (value === currentPassword) {
                    return "New Password must be different from current password.";
                  }
                },
              }}
              render={({ field: { onChange, value } }) => (
                <Input
                  placeholder="New password"
                  type="text"
                  value={value}
                  onChange={onChange}
                />
              )}
            />

            <Controller
              control={control}
              name="confirm_password"
              rules={{
                required: "Confirm Password is required.",
                validate: (value) => {
                  // console.log(value);
                  // console.log(newPassword);
                  console.log(confirmPassword);

                  if (value !== newPassword) {
                    return "New password must be match with confirm password.";
                  }
                },
              }}
              render={({ field: { onChange, value } }) => (
                <Input
                  placeholder="Confirm password"
                  type="text"
                  value={value}
                  onChange={onChange}
                />
              )}
            />

            <Row>
              <Col sm={12} md={12}>
                <Button
                  text={"Save"}
                  className=" blackBg"
                  type="submit"
                  disabled={isLoading}
                />
              </Col>
            </Row>
          </Form>
        </div>
      </ContentContainer>
    </div>
  );
};

export default ChangePassword;
